import React from "react";
import { Text } from "basis";

import Link from "../../Link";
import { FEES, MONTHLY_FEES, RATES } from "./constants";
import { calculateTotals } from "./utils";
import { currencyFormat } from "../../../utils";

export const Flexible = ({
  onLearnMoreClick = () => { },
  promotion,
  amount,
  currency,
  learnMoreURL,
  au,
  nz,
}) => {
  const { promotionMonths } = promotion;

  const { monthlyFees, totalPrice } = calculateTotals(
    amount,
    currency,
    promotionMonths
  );
    const monthlyPrice = currencyFormat(MONTHLY_FEES[currency]);

  const AU = () => (
    <>
 
            <Text textStyle="body2" margin="0 0 3">
        <strong>
   
       Make payments at any time it suits you during the plan period.
        </strong>{" "}
        </Text>
                  <Text textStyle="body2" margin="0 0 3">
                      <strong>Monthly credit card fee (currently ${monthlyPrice})</strong> will apply. 
                      After the interest free plan ends interest will be charged on any
                      outstanding balance at the expired plan rate, currently {RATES.GEM_VISA_AU}%
                      p.a. (subject to change).
                    </Text>
        {!window.location.pathname.includes('/payment/complete') && (
          <Link
            href={learnMoreURL}
            onClick={onLearnMoreClick}
            newTab
            smallFont
            inline
          >
            Learn more
          </Link>
        )}
 
{/* 
      <Text textStyle="body2" margin="3 0">
        You need to pay the purchase amount in equal monthly instalments over
        the plan period.
      </Text> */}
    </>
  );

  const NZ = () => (
    <>
      <Text textStyle="body2" margin="0 0 3">
        <strong>
          Make payments at any time it suits you during the plan period.
        </strong>
      </Text>

      <Text textStyle="body2" margin="0 0 3">
        Interest applies on any outstanding balance at the end of your plan period. Standard interest rate (currently ${RATES.GEM_VISA_NZ} p.a.(subject to change)) applies after interest free term ends.
      </Text>

      {!window.location.pathname.includes('/payment/complete') && (
        <Link href={learnMoreURL} onClick={onLearnMoreClick} newTab smallFont>
          Learn more
        </Link>
      )}
    </>
  );

  return (
    <>
      {au && <AU />}
      {nz && <NZ />}
    </>
  );
};
